import { Box } from '@dixa/lib-shared-habla';
import { colors } from '@dixa/lib-shared-tokens';
import { PropsWithChildren, PropsWithClassName } from 'lib-shared-types-utils';
import { ComponentProps } from 'react';


import { ConversationMessageEventBoxVariant } from './conversationMessageEventBox.types';

/**
 * Represents the styles of the variants.
 *
 * Note that background and border color should always be provided to make the
 * presentation work correctly.
 */
export const variantConfig: Record<
  ConversationMessageEventBoxVariant,
  ComponentProps<typeof Box>
> = {
  textualInbound: {
    background: colors.neutral['000'],
    borderColor: colors.neutral['000'],
  },
  textualOutbound: {
    background: colors.neutral[100],
    borderColor: colors.neutral[100],
  },
  audio: {
    background: colors.neutral['000'],
    borderColor: colors.neutral[200],
  },
  internalNote: {
    background: colors.orange[100],
    borderColor: colors.orange[200],
  },
};

type ConversationMessageEventBoxProps = PropsWithChildren &
  PropsWithClassName & {
    /** The variant of the message. */
    variant: ConversationMessageEventBoxVariant;
  };

/**
 * Represents the component for rendering a conversation message based event,
 * such as internal message, textual message or audio message.
 */
export const ConversationMessageEventBox = ({
  className,
  children,
  variant,
}: ConversationMessageEventBoxProps): JSX.Element => {
  return (
    <Box
      {...variantConfig[variant]}
      className={className}
      padding="300"
      borderWidth="100"
      borderRadius="100"
    >
      {children}
    </Box>
  );
};
